import React from 'react';
import { X } from 'lucide-react';
import classNames from 'classnames/bind';
import styles from './CartHeader.module.scss';

const cx = classNames.bind(styles);

const CartHeader = ({
    onClose,
    title = "In My Bag",
    className
}) => {
    return (
        <div className={cx("cart-header", className)}>
            <div className={cx("cart-header__left")}>
                <div className={cx("cart-icon")}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="8" cy="21" r="1" />
                        <circle cx="19" cy="21" r="1" />
                        <path d="m2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                    </svg>
                </div>
                <h2 className={cx("cart-title")}>{title}</h2>
            </div>
            <button
                className={cx("cart-close")}
                onClick={onClose}
            >
                <X size={24} />
            </button>
        </div>
    );
};

export default CartHeader;
